export default __webpack_public_path__ + "static/media/ic_school_48px.75993a81.svg";